import { defineMessages, useIntl } from 'react-intl'
import { ListingStatusEnum } from '../types/listingStatus'

export const MSG = defineMessages({
  pending: {
    id: 'Listings.status.pending',
    defaultMessage: 'Under Contract',
  },
  active: {
    id: 'Listings.status.active',
    defaultMessage: 'Available',
  },
  inactive: {
    id: 'Listings.status.inactive',
    defaultMessage: 'Inactive',
  },
})

const PendingIcon = () => (
  <svg
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4 0L8 8H0L4 0Z' fill='#9676EE' />
  </svg>
)

const ActiveIcon = () => (
  <svg
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='4' cy='4' r='4' fill='var(--brand-success-600)' />
  </svg>
)

const InactiveIcon = () => (
  <svg
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.16537 0L8 0.86031L4.85683 4L7.99112 7.13969L7.14761 8L3.98668 4.87805L0.887902 8L0.00887902 7.13969L3.14317 4L0 0.878049L0.879023 0L4.00444 3.15743L7.16537 0Z'
      fill='#E65156'
    />
  </svg>
)

export const useListingStatusDisplayObj = (status: ListingStatusEnum) => {
  const intl = useIntl()
  switch (status) {
    case ListingStatusEnum.PENDING:
      return {
        icon: PendingIcon,
        text: intl.formatMessage(MSG.pending),
      }
    case ListingStatusEnum.ACTIVE:
      return {
        icon: ActiveIcon,
        text: intl.formatMessage(MSG.active),
      }
    case ListingStatusEnum.INACTIVE:
      return {
        icon: InactiveIcon,
        text: intl.formatMessage(MSG.inactive),
      }
    default:
      return {
        icon: ActiveIcon,
        text: intl.formatMessage(MSG.active),
      }
  }
}
